import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { DateService } from 'src/app/common/date.service';

@Component({
	selector: 'app-drivers-select-month',
	templateUrl: './drivers-select-month.component.html',
	styleUrls: ['./drivers-select-month.component.css'],
})
export class DriversSelectMonthComponent implements OnInit {
	@Input() editable;
	@Output() changeMonth = new EventEmitter<string>();

	selectedMonth;

	constructor() {}

	setDate(offset = 0): void {
		this.selectedMonth = new DateService().monthsAdd(offset, this.selectedMonth).slice(0, -3);
		this.changeMonth.emit(this.selectedMonth);
	}

	ngOnInit(): void {
		this.setDate(-1);
	}
}
